// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__ddkl_","upload":"Small_upload__SLnjl","imageWrap":"Small_imageWrap__2rTu9","removeBtn":"Small_removeBtn__3HXyk"};